import React from 'react';
import { useDeletePostComment } from '@components/Feed/Post/Comments/useDeletePostComment';
import { ConfirmModal } from '@components/main-components/confirm-modal';
import { useModal } from '@context/modal';

export function DeletePostCommentModal({ postCommentId }: { postCommentId: string }) {
  const { closeModal } = useModal();
  const { deletePostComment, loading } = useDeletePostComment({
    postCommentId,
    onDeleteSuccess: () => {
      closeModal();
    },
  });
  return (
    <ConfirmModal
      onConfirm={deletePostComment}
      onCancel={closeModal}
      title="Delete Comment?"
      message="Are you sure you want to delete your comment? This action cannot be undone."
      confirmText="Delete"
      cancelText="Cancel"
      destructive
      loading={loading}
    />
  );
}
